import button_vue_vue_type_script_setup_true_lang_default from "./button.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/button/src/button.vue
var button_default = button_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { button_default as default };
//# sourceMappingURL=button2.mjs.map